export default {"src":"/_next/static/media/ic-next.1d98b818.svg","height":7,"width":4,"blurWidth":0,"blurHeight":0};